export default "__VITE_PUBLIC_ASSET__ce264cf4__"